export const HEADER_TITLE = 'Middle School Units Have Changed'
export const BODY_TEXT =
  'Grades 6-8 have a new Unit 2: Developing a Positive Sense of Self. The Recognizing Bullying & Harassment unit is now optional.'
export const STATUS_TEXT = 'Recognizing Bullying & Harrassment Unit:'
export const SETTING_BUTTON_TEXT = 'Unit Settings'
export const DISMISS_BUTTON_TEXT = 'Dismiss'
export const LINK_TEXT = "See What's Changing"
export const COOKIE_NAME = 'MspBullyingNotificationDismissed'
